var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        `experta__chat-message`,
        `experta__chat-message--${_vm.message.sender}`,
        `experta__chat-message--${_vm.message.type}`
    ]},[(_vm.isMessageTypeText)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.message.content)}}):(_vm.isMessageTypeQuestion)?_c('div',{on:{"click":function($event){return _vm.askExperta(_vm.message.content)}}},[_vm._v(" "+_vm._s(_vm.message.content)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }